<template>
  <b-modal
    ref="loadingModal"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    centered
    hide-footer
    v-bind:title="title"
  >
    <div class="d-block text-center">
      <p>
        <b-spinner variant="red" label="Large Spinning"/>
      </p>
      <p>{{ body }}</p>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalLoading',
  data() {
    return {
      title: 'ระบบกำลังโหลดข้อมูล',
      body: 'กรุณารอสักครู่'
    }
  },
  mounted() {
    Window.Event.$on('showModalLoading', this.showModal)
    Window.Event.$on('closeModalLoading', this.closeModal)
  },
  beforeDestroy () {
    Window.Event.$off('showModalLoading')
    Window.Event.$off('closeModalLoading')
  },
  methods: {
    showModal: function(textTitle, textBody) {
      this.title = textTitle == undefined ? 'ระบบกำลังโหลดข้อมูล' : textTitle
      this.body = textBody == undefined ? 'กรุณารอสักครู่' : textBody
      if (this.$refs.loadingModal !== undefined) {
        this.$refs.loadingModal.show()
      }
    },
    closeModal: function() {
      if (this.$refs.loadingModal !== undefined) {
        this.$refs.loadingModal.hide()
      }
    }
  }
}
</script>

